jQuery(document).ready ($) ->
	$fancyboxThumb = $ '.fancybox-thumb'
	unless $fancyboxThumb.length > 0
		return

	$fancyboxThumb.fancybox
		prevEffect: 'none'
		nextEffect: 'none'
		helpers:
			thumbs:
				width: 50
				height: 50


/** WEBPACK FOOTER **
 ** ./assets/coffee/modules/fancybox.coffee
 **/